import React, { useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "./components/loader"
import PasswordInput from "./components/passwordInput"
import URLBASE from "../api/urlRegister"
import '../App.css';

const initialState = {
	email: '',
	senha: '',
}

const Login = () => {
	
	const navigate = useNavigate();
	
	const notificationError = message => toast.error(message);
	
	const [login, setLogin] = useState(initialState);
	const [loading, setLoading] = useState(false);

	async function postLoginForm(e){
		e.preventDefault();
		let urlPost = URLBASE + "/login"
		try{

			setLoading(true)
			const response = await fetch(urlPost, {
							method: 'POST',
							headers: {
							  'Accept': 'application/json',
							  'Content-Type': 'application/json'
							},
							body: JSON.stringify({
								email: login.email,
								senha: login.senha,
							})
						  });
			const content = await response.json();
			if(content.status === "True"){				 
				/* coloca o token e o id da loja no local storage */
				sessionStorage.setItem("tkn", content.token);
				sessionStorage.setItem("idl", content.id);
				navigate("/cadastro-loja")
			}else{
				notificationError(content.mensagem);
			}

		}catch(error){
			notificationError('Um erro interno ocorreu.');
		}finally{
			setLoading(false)
		}
	}
	
	function handleCadastroNavigate(){
		sessionStorage.setItem("tkn", "");
		sessionStorage.setItem("idl", "");
		navigate("/cadastro-loja")
	}
	
	const handlePassword = e => {
		setLogin(prevState => ({ ...prevState, senha: e.target.value}));
	}
			
	return (
	

					<div id="row-login" className="row">
						<div className="col-sm coluna-lateral"></div>
						<div id="custom-col-login" className="col-lg-5">
							<div id="login" className="card shadow-sm rounded">
															
								<div style={{marginBottom: "10px"}}><center><a style={{color: "#22a1ff"}} href="https://www.minhaencomenda.me/" target="_blank" aria-hidden="true" rel="noreferrer">
									<h4><b>Minha Encomenda</b></h4>
								</a></center></div>
									
								<center><p>Faça o login para visualizar ou editar as informações da sua página de rastreio customizada Minha Encomenda.</p></center>
			
								<form style={{marginTop: "10px"}} onSubmit={postLoginForm}>
								  
								  <input placeholder="Seu e-mail" id="email" type="email" required name="email" className="form-control shadow-none" autoComplete="on" value={login.email} onChange={(e) => setLogin(prevState => ({ ...prevState, email: e.target.value}))} /><br/>
								  
								  <PasswordInput placeholder="Sua senha" senha={login.senha} onChangeFunc={handlePassword} titleTooltip="clique para mostrar ou esconder a senha" tooltipPosition="top" checkPassword={false} />
								  
								  <div style={{marginTop: "22px"}}><center><small><Link to="/enviar-email">Esqueceu a senha?</Link></small></center></div>

								  <br/>

								  <button id="btn-login" className="btn shadow-none">{loading ? <Loader small={true} color={"#ffffff"} /> : 'Entrar'}</button><br/>								  
								  
								</form>
								<button className="btn btn-outline-primary shadow-none" style={{marginBottom: '6px'}} onClick={(e) => handleCadastroNavigate()}>Cadastrar</button>
							
							</div>
						</div>
						<div className="col-sm coluna-lateral"></div>
					</div>

	
	)
}
	

export default Login;
